import { FORM_ERROR } from 'final-form';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as loginActions from '../../actions/auth';
import * as checkoutActions from '../../actions/checkout';
import * as inmateActions from '../../actions/inmate';
import * as onlineUserActions from '../../actions/online-user';
import * as postOfficeActions from '../../actions/post-office';
import { FacilityFeature } from '../../models/Facility';
import { IInmate } from '../../models/Inmate';
import { IOnlineUser } from '../../models/OnlineUser';
import { IAppState } from '../../reducers';
import LoginOrRegister from '../Checkout/LoginOrRegister';
import FacilitySearch from '../Facility/Search';
import InmatePicker from '../Inmate/Picker';
import PageTitle from '../PageTitle';
import Container from './Container';
import EnvelopeDisplay from './EnvelopeDisplay';

const Send: React.FC = () => {
  const [selectedInmate, setSelectedInmate] = useState<IInmate>(null);
  const state = useSelector((appState: IAppState) => ({
    auth: appState.auth,
    checkout: appState.checkout,
    common: appState.common,
    postOffice: appState.postOffice
  }));
  const dispatch = useDispatch() as ThunkDispatch<IAppState, undefined, Action>;

  useEffect(() => {
    // Load the available inmates
    if (state.checkout.common.facility && state.postOffice.inmates == null) {
      dispatch(inmateActions.loadInmates(state.checkout.common.facility.id));
    }
  }, [state.checkout.common.facility]);

  if (state.checkout.common.facility == null) {
    return (
      <Container
        onResetService={() => dispatch(checkoutActions.selectService(null))}
        facility={null}>
        <FacilitySearch
          facilitiesLoading={state.common.loadingFacilities}
          facilities={state.common.facilities}
          onSubmit={facility =>
            dispatch(checkoutActions.selectFacility(facility[0]))
          } />
      </Container>
    )
  }

  if (!state.checkout.common.facility.features.includes(FacilityFeature.MailConnect)) {
    return <Redirect to="/checkout/facility" />
  }

  if (!state.auth.loggedIn) {
    return (
      <Container
        onResetService={() => dispatch(checkoutActions.selectService(null))}
        facility={state.checkout.common.facility}>
        <LoginOrRegister
          title="Reliance Mail Connect"
          serviceCssClass="postoffice"
          onLogin={(emailAddress, password) =>
            dispatch(loginActions.login(emailAddress, password))
              .catch(err => {
                return { [FORM_ERROR]: err.error ? err.error : err };
              })
          }
          onRegister={(emailAddress, password) =>
            dispatch(onlineUserActions.register(emailAddress, password))
              .catch(err => {
                return { [FORM_ERROR]: err.error ? err.error : err };
              })
          } />
      </Container>
    )
  }

  if (
    (state.postOffice.data == null || state.postOffice.data.inmate == null) &&
    !selectedInmate
  ) {
    return (
      <Container
        onResetService={() => dispatch(checkoutActions.selectService(null))}
        facility={state.checkout.common.facility}>
        <InmatePicker
          facility={state.checkout.common.facility}
          loadingInmates={state.postOffice.inmatesLoading}
          inmates={state.postOffice.inmates || []}
          selectedInmate={selectedInmate}
          onSelect={inmate => {
            setSelectedInmate(inmate);
            dispatch(postOfficeActions.setInmate(inmate));
            window.scrollTo(0, 0);
          }} />
      </Container>
    );
  }

  const displayInmate = state.postOffice.data?.inmate || selectedInmate;

  return (
    <>
      <PageTitle title="Send Mail" />
      <EnvelopeDisplay
        user={state.auth.user as IOnlineUser}
        inmate={displayInmate}
        facility={state.checkout.common.facility} />
    </>
  )
}

export default Send